var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNeutralEmoji = function SvgIconNeutralEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#040512",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16M15.2 14.2H8.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#040512",
    fillRule: "evenodd",
    d: "M8.6 9.6a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2H9.6a1 1 0 0 1-1-1M13.4 9.6a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2H14.4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconNeutralEmoji;